import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMail, FiMapPin, FiFacebook, FiTwitter, FiInstagram, FiLinkedin } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* Notice Section */}
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 my-8 mx-4 rounded-r-lg">
        <div className="flex">
          <div className="flex-shrink-0">
            <span className="text-yellow-400 text-xl">⚠️</span>
          </div>
          <div className="ml-3">
            <p className="text-sm text-yellow-700">
              <strong>Notice:</strong> This website is created only for student practice. Account4Web experts have not fixed technical issues here – so you can clearly see the real work level of students. Almost 80% of the website is perfect, and the remaining 20% is polished by experts in final projects. 🔒 We never share any client website made under this offer with others – your project privacy is 100% safe.{' '}
              <a 
                href="https://projects.azaansuperpc.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="font-medium underline hover:text-yellow-800"
              >
                👉 Check Offer
              </a>
            </p>
          </div>
        </div>
      </div>

      <footer className="bg-navy-900 text-white">
        <div className="container mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="space-y-4">
              <div className="flex items-center space-x-2">
                <div className="bg-primary-500 p-2 rounded-lg">
                  <SafeIcon icon={FiIcons.FiTool} className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-xl font-bold">BuildCorp</h3>
                  <p className="text-gray-300 text-sm">Construction Excellence</p>
                </div>
              </div>
              <p className="text-gray-300">
                Professional construction services with over 25 years of experience. 
                Building better worlds through quality construction and innovative solutions.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-300 hover:text-primary-500 transition-colors">
                  <SafeIcon icon={FiFacebook} className="w-5 h-5" />
                </a>
                <a href="#" className="text-gray-300 hover:text-primary-500 transition-colors">
                  <SafeIcon icon={FiTwitter} className="w-5 h-5" />
                </a>
                <a href="#" className="text-gray-300 hover:text-primary-500 transition-colors">
                  <SafeIcon icon={FiInstagram} className="w-5 h-5" />
                </a>
                <a href="#" className="text-gray-300 hover:text-primary-500 transition-colors">
                  <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-gray-300 hover:text-primary-500 transition-colors">Home</Link></li>
                <li><Link to="/about" className="text-gray-300 hover:text-primary-500 transition-colors">About Us</Link></li>
                <li><Link to="/services" className="text-gray-300 hover:text-primary-500 transition-colors">Services</Link></li>
                <li><Link to="/projects" className="text-gray-300 hover:text-primary-500 transition-colors">Projects</Link></li>
                <li><Link to="/contact" className="text-gray-300 hover:text-primary-500 transition-colors">Contact</Link></li>
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Our Services</h4>
              <ul className="space-y-2">
                <li><span className="text-gray-300">Residential Construction</span></li>
                <li><span className="text-gray-300">Commercial Building</span></li>
                <li><span className="text-gray-300">Industrial Projects</span></li>
                <li><span className="text-gray-300">Renovation & Remodeling</span></li>
                <li><span className="text-gray-300">Project Management</span></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiMapPin} className="w-5 h-5 text-primary-500" />
                  <span className="text-gray-300">123 Construction Ave, Builder City, BC 12345</span>
                </div>
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiPhone} className="w-5 h-5 text-primary-500" />
                  <span className="text-gray-300">+1 (555) 123-4567</span>
                </div>
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiMail} className="w-5 h-5 text-primary-500" />
                  <span className="text-gray-300">info@buildcorp.com</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 text-sm">
              © {currentYear} BuildCorp Construction. All rights reserved.
            </p>
            <p className="text-gray-300 text-sm mt-4 md:mt-0">
              Domain + Hosting + Design = {' '}
              <a 
                href="https://account4web.ca" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary-500 hover:text-primary-400 font-medium"
              >
                Account4Web Inc
              </a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;